import {Link} from 'react-router-dom'
import logo from '../media/Balanz_white_logo.svg'

export const CheckYourEmail = () => {
  return (
    <div className='columns w-row container-log-check'>
      <div className='logocolumn w-col w-col-4 w-col-stack'>
        <img
          src={logo}
          loading='lazy'
          alt='Balanz logo'
          width='600'
          sizes='(max-width: 479px) 63vw, (max-width: 767px) 43vw, (max-width: 991px) 36vw, 23vw'
          className='loginlogo'
        />
      </div>
      <div className='formcolumn w-col w-col-8 w-col-stack'>
        <div className='form w-form'>
          {/* <a href='../../cliente/new-user/new-user.html' className='back-button w-inline-block'></a> */}
          <form
            id='wf-form-verification-code'
            name='wf-form-verification-code'
            data-name='verification-code'
            method='get'
          >
            <h3 className='h2-titles'>Please check your email to continue</h3>
            <p className='paragraph'>We have sent an account recovery link </p>
            <Link to='/'>
              <input
                type='submit'
                data-wait=''
                value='Back to Login'
                className='button continue w-button'
              />
            </Link>
          </form>
        </div>
      </div>
    </div>
  )
}
